export default __webpack_public_path__ + "static/media/saturday-open.8e853f8c.jpeg";